import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CategoryService } from '../header/service/category.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cat-carousel',
  templateUrl: './cat-carousel.component.html',
  styleUrls: ['./cat-carousel.component.css']
})
export class CatCarouselComponent implements OnInit {

constructor(private categoryService: CategoryService, private router: Router) { }

  categoryImages: any = [
    
  ];

   visibleImages: any = [];
  startIndex: number = 0;
  itemsPerView: number = 4;

  @ViewChild('carouselContainer', { static: true }) carouselContainer!: ElementRef;

  touchStartX: number = 0;
  touchEndX: number = 0;
  categories = [];

  ngOnInit() {
     this.categoryService.getCategories().subscribe(res => {
       this.categoryImages = [];
      this.categories = res;
      this.categories.forEach(element => {
        element.categoryImage = environment.globalImagePath + 'CategoryImage/' + element.categoryImage;
        this.categoryImages.push({ Id: element.id, image: element.categoryImage })
      });
         this.updateVisibleImages();
    
    });
  
  }


  navigateToProducts(catId) {
   
    localStorage.setItem('p_category', catId)
    this.router.navigate(['/products']);
  }

  updateVisibleImages() {
    this.visibleImages = this.categoryImages.slice(
      this.startIndex,
      this.startIndex + this.itemsPerView
    );
  }

  prevImage() {
    if (this.startIndex > 0) {
      this.startIndex--;
      this.updateVisibleImages();
    }
  }

  nextImage() {
    if (this.startIndex + this.itemsPerView < this.categoryImages.length) {
      this.startIndex++;
      this.updateVisibleImages();
    }
  }

  // Swipe start
  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  // Swipe end
  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipeGesture();
  }

  // Handle swipe logic
  handleSwipeGesture() {
    const swipeThreshold = 50; // Minimum distance for a swipe
    const swipeDistance = this.touchEndX - this.touchStartX;

    if (swipeDistance > swipeThreshold) {
      // Swipe right
      this.prevImage();
    } else if (swipeDistance < -swipeThreshold) {
      // Swipe left
      this.nextImage();
    }
  }

}
